import React,{useEffect,useState} from 'react';
import './BannerHomePage.scss'
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';

function AccordionDesktop(props) {
    const [visibility,setVisibility] = useState('visible');
    const {
        item,
        i,
        activeIndex,
        setActiveIndex,
        setIsActiveIntervalAutoOpenBanner,
        setButtonTextByIndexId,
        buttonOnBanner,
        getButtonClassByName,
        gtag4,
        switchExtraction,
        context
    } = props;

    const {
        priTitle,
        secTitle,
        textBanner,
        titleBannerClose,
        imageBanner,
        backgroundColor,
        buttonText,
        linkBanner,
        isBannerClickable
    } = item;

    // A few seconds until the text of the banner appears in its opening state
    useEffect(()=>{
        let setTimeForTextBannerOpen = setTimeout(()=>{
            setVisibility('visible')
        },700)
        setVisibility('hidden')
        return () => clearTimeout(setTimeForTextBannerOpen);
    },[activeIndex])

    //  click on item background banner
    const clickItemBannerToOpen = (i) => {
      setActiveIndex(i);
      setIsActiveIntervalAutoOpenBanner(false)
      if(activeIndex !== i ){
        gtag4({ // Google analytic 4
          event:'HomepageCarousel_BannerImp',
          category: titleBannerClose,
          section: 'HomepageCarousel',
          title: switchExtraction(priTitle),
          content: switchExtraction(textBanner),
          place: i,
        });
      }
  };

  const clickBanner = ()=>{
    if (isBannerClickable && linkBanner != null) {
        prepareUrl(linkBanner, context);
    };
  };

  return (
    <li
        onClick={() => clickItemBannerToOpen(i)}
        className={`wrapper-banner-item ${activeIndex === i ? 'open' : ''} `}
        style={{ backgroundColor: `${backgroundColor}`}}
    >
            {activeIndex === i
                ? /* text and image-light for only open banner */
                <div 
                onClick={() => clickBanner(i)} 
                className={`image-item-open ${isBannerClickable ? 'click-banner' : ''}`}
                style={{ backgroundImage: `url(${imageBanner.src})`}}
                >
                    <div className={`text-banner-open ${item.isWhiteText ? 'white-text' : ''}`} style={{visibility: visibility}}>
                        <div className='only-text-banner'>
                            {priTitle.length > 0 && <div className='pri-title' dangerouslySetInnerHTML={{ __html: priTitle }} />}
                            {secTitle.length > 0 && <div className='sec-title' dangerouslySetInnerHTML={{ __html: secTitle }} />}
                            {textBanner.length > 0 && <div className='text-banner' dangerouslySetInnerHTML={{ __html: textBanner }} />}
                        </div>
                            {
                                !isBannerClickable &&
                                <button className={getButtonClassByName(i)} onClick={() => buttonOnBanner(item,i)}>
                                    {setButtonTextByIndexId(i)}
                                </button>
                            }
                    </div>
                </div>
                : /* text and image-darkness for only close banner */
                <div className='image-item-close'  style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)),url(${imageBanner.src})`}}>
                    <div className='container-title-banner-close'>
                        <p className='title-banner-close'>{titleBannerClose}</p>
                    </div>
                </div>

            }

    </li>
  )
}

export default AccordionDesktop;
